<template>
  <div class="card-single" :class="templateClass">
    <div class="card-single__wrapper">
      <!-- notifications area -->
      <transition name="scale">
        <slot name="notifications" />
      </transition>
      <!-- body -->
      <div class="card-single__body">
        <div class="card-single__header">
          <slot name="body-header" />
        </div>
        <div class="card-single__details">
          <slot name="body-details" />
        </div>
      </div>
      <!-- footer -->
      <div class="card-single__footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardSingleLayout',
  props: {
    template: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    templateClass() {
      return this.template && 'template'
    },
  },
}
</script>

<style scoped>
/* main */
.card-single {
  border-radius: 8px;
  background-color: var(--c-secondary-100);
  user-select: none;
  -moz-user-select: none;
  cursor: pointer;
  transition: 0.3s all;
  will-change: transform;
  backface-visibility: hidden;
  z-index: 0;
}

.card-single__wrapper {
  display: grid;
  position: relative;
  height: 100%;
}

.card-single:hover {
  box-shadow: 0 1px 10px 0 rgb(60 64 67 / 30%), 0 1px 3px 1px rgb(60 64 67 / 15%);
  z-index: 1;
}
/* body */
.card-single__body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex-grow: 1;
  padding: 10px;
  min-height: 150px;
}
/* details */
.card-single__details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;
  row-gap: 10px;
  width: 100%;
  margin-top: 35px;
}
/* footer */
.card-single__footer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-self: flex-end;
  background-color: var(--c-secondary-400);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
  height: 30px;
}
</style>
